import WatermarkImage from "../Assets/Watermark.svg";

function Watermark() {
  return (
    <div className="watermark-icon container">
      <div className="watermark-opacity-box"></div>
      <div className="watermark">
        <img src={WatermarkImage} alt="" />
      </div>
    </div>
  );
}

export default Watermark;
